<template>
  <div class="ml-2" v-if="websites.length > 1 && user?.type !== 'admin_delivery'">
    <autocomplete
      v-model="site"
      :items="websites"
      hide-details
      item-text="name"
      item-value="id"
      return-object
    />
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "SitesDropdown",
  computed: {
    ...mapState({
      user: (state) => state.user.user,
    }),

    websites() {
      return this.user?.restaurants || [];
    },
    site: {
      get() {
        return this.$store.state.selectedRestaurant;
      },
      set(value) {
        this.selectRestaurant(value);
      },
    },
  },
  watch: {
    websites: {
      handler: function (newWebsites) {
        if (newWebsites.length > 0 && !this.site) {
          const savedId = localStorage.getItem("restorani-selected-restaurant");
          const saved = savedId && newWebsites.find((w) => String(w.id) === savedId);
          this.selectRestaurant(saved || newWebsites[0]);
        }
      },
      immediate: true,
    },
  },
  methods: {
    // selectedRestaurant je samo za prikaz (SitesDropdown/AppBar naziv);
    // state.restaurant je stvarni radni kontekst koji čitaju sve
    // restoranske stranice (finansije, meni...) za restaurants/{id} pozive -
    // moraju se menjati zajedno, inače izbor u dropdown-u ne utiče na podatke.
    selectRestaurant(value) {
      this.$store.commit("SET_SELECTED_RESTAURANT", value);
      this.$store.commit("SAVE_RESTAURANT", value);
    },
  },
};
</script>

<style scoped>
/* Možemo dodati custom stilove ako je potrebno */
</style>
